import { IFetchResult } from 'src/core/classes/helpers/store/Interfaces'
import { IMarkets, IRegions } from 'src/core/classes/models/IMarkets'

const dataRegions = [
  {
    EntryId: 1,
    Region: 'AMS',
  },
  {
    EntryId: 2,
    Region: 'APJ',
  },
  {
    EntryId: 3,
    Region: 'EMEA',
  },
]

const dataMarkets = [
  {
    EntryId: 1,
    Region: 'AMS',
    Market: 'Latin America',
  },
  {
    EntryId: 2,
    Region: 'APJ',
    Market: 'Greater Asia',
  },
  {
    EntryId: 4,
    Region: 'EMEA',
    Market: 'EMEA',
  },
  {
    EntryId: 6,
    Region: 'APJ',
    Market: 'Greater China',
  },
  {
    EntryId: 7,
    Region: 'APJ',
    Market: 'India, B&SL',
  },
  {
    EntryId: 8,
    Region: 'AMS',
    Market: 'North America',
  },
]

// TODO remove market api
export const MarketApi = {
  fetchRegions: (): IFetchResult<IRegions> => {
    return {
      items: dataRegions,
      total: dataRegions.length,
    }
  },
  fetchMarkets: (): IFetchResult<IMarkets> => {
    return {
      items: dataMarkets,
      total: dataMarkets.length,
    }
  },
  fetchRegionByMarket: (Market: string): IFetchResult<IRegions> => {
    const regionM = dataMarkets.filter((i: IMarkets) => i.Market === Market)
    const regionStr = regionM && regionM[0] ? regionM[0].Region : ''
    const data = dataRegions.filter((i: IRegions) => i.Region === regionStr)
    return {
      items: data,
      total: data.length,
    }
  },
  getRegion(market: string): IRegions {
    const row = this.fetchRegionByMarket(market)
    return (
      (row && row.items[0]) || {
        EntryId: -1,
        Region: 'EMEA',
      }
    )
  },
}
